var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.dynamicComponent,{tag:"component",staticClass:"list-group-item list-group-header",attrs:{"to":_vm.link}},[_c('h6',{staticClass:"mb-0 float-left"},[_vm._t("default")],2),(_vm.link)?_c('b-icon',{staticClass:"float-right",attrs:{"icon":"chevron-right"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }